export default __webpack_public_path__ + "static/media/customer-support.d6b23234.svg";